import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';

import { ButtonRefresh } from '»components/atoms';
import { loginSlice } from '»components/Auth';
import { getActiveMenuItemSelector } from '»components/Menus';
import {
  useCurrentPage,
  usePageNavigation,
  useUserAuthentication,
} from '»utils/customHooks';
import { useIsAbleToProceed } from '»utils/customHooks/useIsAbleToProceed';
import { TrlFormattedMessagePlain } from '»utils/i18n';

import {
  LeftArrowIconStyled,
  ListMobileStyled,
  ListWrapper,
  NavigationLabel,
} from './TrlNavigationFooter.styles';

export const TrlNavigationFooter = ({
  children,
  isOnlyForNavigation,
  navigationLabel,
}) => {
  const dispatch = useDispatch();
  const location = useLocation();

  const activeMenuItem = useSelector(getActiveMenuItemSelector);

  const { isUserAuthenticated } = useUserAuthentication();
  const { navigateToPage } = usePageNavigation();
  const {
    isLoginValidationStep,
    isFundsOrdersDetailsPage,
    isMarketStockExchangeDetailsPage,
    isFundsDetailsPage,
    isStockExchangeOrdersDetailsPage,
    isOnboardingAdvancedSteps,
  } = useCurrentPage(location.pathname);

  const { isAbleToProceed } = useIsAbleToProceed();

  const alertMessage = TrlFormattedMessagePlain({
    id: 'TRLT_UI-LEAVE_PAGE_ALERT',
  });

  return (
    <ListWrapper
      isOnlyForNavigation={isOnlyForNavigation}
      isAtBottom={!isUserAuthenticated}
    >
      <ListMobileStyled
        component="div"
        disablePadding
        opened
        isOnlyForNavigation={isOnlyForNavigation}
      >
        <LeftArrowIconStyled
          icon={faArrowLeft}
          onClick={(event) => {
            const confirmLeave =
              isOnboardingAdvancedSteps && window.confirm(alertMessage);
            if (!confirmLeave && isOnboardingAdvancedSteps) {
              event.preventDefault();
              return;
            }

            if (activeMenuItem.includes('GENERIC:SETTINGS')) {
              isAbleToProceed(event, () => {
                navigateToPage({
                  route: '/Settings',
                  menuItem: 'GENERIC:SETTINGS',
                });
              });
            } else if (isStockExchangeOrdersDetailsPage) {
              navigateToPage({
                route: '/Trading/StockExchange',
                menuItem: 'TRADING:BOLSA',
              });
            } else if (isMarketStockExchangeDetailsPage) {
              navigateToPage({
                route: '/Market/StockExchange',
                menuItem: 'MARKET:BOLSA',
              });
            } else if (isFundsDetailsPage) {
              navigateToPage({
                route: '/Market/Funds',
                menuItem: 'MARKET:FUNDS',
              });
            } else if (isFundsOrdersDetailsPage) {
              navigateToPage({
                route: '/Trading/Funds',
                menuItem: 'TRADING:FUNDS',
              });
            } else if (isLoginValidationStep) {
              dispatch(
                loginSlice.actions.setLoginCurrentStep({
                  direction: 'backward',
                }),
              );
            } else {
              navigateToPage({
                route: '/',
                menuItem: 'LANDING_PAGE',
                shouldResetAuth: true,
                shouldResetQuest: true,
              });
            }
          }}
          isOnlyForNavigation={isOnlyForNavigation}
        />
        {isOnlyForNavigation ? (
          <NavigationLabel>
            <FormattedMessage id={navigationLabel} />
          </NavigationLabel>
        ) : (
          <>
            {children}
            <ButtonRefresh />
          </>
        )}
      </ListMobileStyled>
    </ListWrapper>
  );
};

TrlNavigationFooter.propTypes = {
  children: PropTypes.element,
  isOnlyForNavigation: PropTypes.bool,
  navigationLabel: PropTypes.string,
};
